import { HTTP } from '../../utils/http';

export const UsersInvitationService = {
    createInvite(form) {
        return HTTP.post('/users/invites', form);
    },

    createInviteBulk(userId, schoolId, file) {
        const formData = new FormData();
        formData.append('invites-file', file);
        const headers = {'Content-Type': 'multipart/form-data'};
        return HTTP.post(`/users/invites/csv-import?id=${userId}&schoolId=${schoolId}`, formData, { headers });
    },

    confirmInvitation(form, token) {
        return HTTP.post(`/no-auth/users/invites?token=${token}`, form);
    },

    toggleUserStatus(schoolId, userId) {
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/discard-invite`);
    },

    deleteUser(schoolId, userId) {
        return HTTP.delete(`/schools/${schoolId}/users/${userId}`);
    },

    deleteMultipleUsers(schoolId, userIds) {
        return HTTP.delete(`/schools/${schoolId}/users?userIds=${userIds}`);
    },

    checkIfUserExists(token) {
        return HTTP.get(`/no-auth/users/invites/exists?token=${token}`);
    },

    createAccountForExistingUser(token) {
        return HTTP.post(`/no-auth/users/invites/existing?token=${token}`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/user-invitation.service.js